import { type, number, literal } from 'superstruct';
import { fireCustomEvent } from './modules/fire-custom-document-event';
export const productVariantSelectedEventType = 'theme:product_variant_selected';
export const ProductVariantSelectedEventType = literal(productVariantSelectedEventType);
export const ProductVariantSelectedEventPayload = type({
    productId: number(),
    variantId: number()
});
export const ProductVariantSelectedEvent = type({
    type: ProductVariantSelectedEventType,
    detail: ProductVariantSelectedEventPayload
});
export const sendProductVariantSelectedEvent = function(payload) {
    fireCustomEvent(productVariantSelectedEventType, payload);
};
